import type { Project, Postech } from '@/types/types'
import { useUserStore, usePileStore } from '@/stores'
import { formatDate } from '@/libs/utils'
import { storeToRefs } from 'pinia';

export function useCloseoutBuilder() {

  const pileStore = usePileStore();
  const { allPiles } = storeToRefs(pileStore);

  /**
   * Builds a Postech Closeout letter from a project object
   * TODO this function should check to see if a file with the name
   * already exists in the folder, then overwrite it if it does.
   * @param {Object} project The project object as a JSON
   * this will include the postech component for closeout
   * @return {String} The url to the created google doc
   */
  async function buildPostechCloseout(project: Project, postech: Postech) {
    console.log('building Postech Closeout Letter for project = ' + JSON.stringify(project))
    Object.keys(project).forEach((key) => {
      console.log('key ' + key, 'value = ', project[key])
    })

    let CofA
    let buildingCode

    switch (project.province) {
      case 'AB':
        CofA = 'APEGA P12834'
        buildingCode = 'National Building Code - 2023 Alberta Edition'
        break

      case 'ON':
        CofA = 'PEO CofA # 100523034'
        buildingCode = '2024 Ontario Building Code'
        break

      case 'BC':
        CofA = 'PTP 1000603'
        buildingCode = '2024 British Columbia Building Code'
        break

      case 'NS':
        CofA = '#51205'
        buildingCode = '2020 National Building Code of Canada'
        break

      case 'SK':
        CofA = 'CofA #51190'
        buildingCode = '2020 National Building Code of Canada'
        break

      case 'NB':
        CofA = 'CofA F2042'
        buildingCode = '2020 National Building Code of Canada'
        break

      case 'MB':
        CofA = 'CofA No. 6099'
        buildingCode = '2020 National Building Code of Canada'
        break

      default:
      //nothing
    }

    //update by replacing the fields with the project fields
    // body.replaceText('{Street Address}',project["streetAddress"]);
    //body.replaceText('{City}',project["city"]);
    //body.replaceText('{Province}',project["province"]);
    //body.replaceText('{Installer}',project.postech.installer);

    //2nd and 3rd paragraphs
    console.log('building 2nd and 3rd paragraph:')
    let para2 = 'There are '
    let para3 = ''
    const piles = postech.piles
    console.log('project.piles = ' + JSON.stringify(piles) + ', piles.length = ' + piles.length)

    //loop through the array of piles and construct the 2nd and 3rd paragraphs TODO calculate the capacity?
    //var j = 0;  //increment on pile entries that aren't blank
    //for(i = 0; i<piles.length; i++ ){
    //const postechStore = usePostechStore()
    //const allPileTypes = await postechStore.getAllPileTypes()
    

    try {
      piles.forEach((pile) => {
        console.log('..looping, pile = ' + JSON.stringify(pile))
        const count = pile.pileCount
        const pileLookup = allPiles.value.find((screwPile) => {
         // console.log(`${pile.pileType} searching for : ${screwPile.name}`);
          return pile.pileType.trim() === screwPile.name.trim()
        }) //match pile object from database to get od
        pile.od_in = pileLookup.od_in
        pile.size = pileLookup.type
        if (para2.length > 12) {
          para2 += ', '
        }
        //para2 += "(" + count +") " + pile.pileType +" (" + pile.od_in + '" diameter) piles ';
        para2 += `(${count}) ${pile.pileType} (${pile.od_in}" diameter) piles `
        para3 += buildPileParagraph_(pile)
      })
    } catch (error) {
      console.log('error on piles for each : ' + error)
    }
    para2 +=
      'that have been installed to support a ' +
      postech.pilesSupporting +
      '. A minimum installation torque value was met as specified by the pile design engineer.'
    console.log('para2 = ' + para2)
    console.log('para3 = ' + para3)

    //4th paragraph:
    const para4 = `All the piles as installed will have the capacity to handle all applied loads as per the latest revisions of the ${buildingCode} for ${project.city} and area.`
    console.log('para4 = ' + para4)
    //get today's date
    //var today = new Date().toDateString();
    //const today = Utilities.formatDate(new Date(),"GMT","MMM dd, yyyy");
    let closeoutDate
    console.log('..postech modified on = ' + postech.modified_on)
    console.log('..typeof modified on = ' + typeof postech.modified_on)
    try {
      closeoutDate = formatDate(new Date(postech.modified_on)) //.toDateString();
    } catch (error) {
      console.log('..postech modified_on doesnt exist')
      closeoutDate = formatDate(new Date())
    }
    //const today = new Date().toLocaleDateString();
    //body.replaceText('{Today}',today);
    //  console.log('today: ' + today);
    //
    //NEW get code data from database
    //const ws = getSheet_(TABLE.CODES);
    //let code = DB.fetchByField('province',project['province'],ws)[0];
    //console.log("code.certificate = " + code.certificate);
    //console.log("code.codeName = " + code.codeName);
    //body.replaceText('{CofA}', code.certificate);
    //body.replaceText('{Building_Code}',code.codeName);
    //

    //add user name and email
    const userStore = useUserStore()
    const title = userStore.currentUser + ', P.Eng'
    const email = userStore.currentEmail
    console.log('title, email = ', title, email)

    //make a shortcut in the project folder to the closeouts folder
    // const projectFolder = DriveApp.getFolderById(project.folderId);
    // let closeoutShortcut = DriveApp.createShortcut(closeoutId).moveTo(projectFolder);
    // const shortCutId = closeoutShortcut.getId();

    //add the custom properties to the shortcut only, as this will be in the project folder
    // setFileProperties_({'fileId' : shortCutId, 'description' : 'template', 'docType' : DOCTYPE.CLOSEOUT_TEMPLATE, 'projectId' : project.projectId });
    //return closeoutShortcut.getUrl(); //return the url

    //var fileName = "Engineering REPORT Screw Pile - Compliance (" + project["streetAddress"] + ", " + project["city"] + ", " + project["province"] + ")";
    const fileName =
      'Engineering REPORT Screw Pile - Compliance (' + project.name + ')'
    // console.log('fileName = ' + fileName);

    const closeout = {
      installer: postech.installer.invoiceName,
      streetAddress: project.streetAddress,
      city: project.city,
      province: project.province,
      name: title,
      CofA: CofA,
      buildingCode: buildingCode,
      email: email,
      paragraph2: para2,
      paragraph3: para3,
      paragraph4: para4,
      folderId: project.folderId,
      filename: fileName,
      date: closeoutDate //pass date as string, use modified_date of postech if exists
    }
    console.log('-------closeout returning:--------')
    Object.keys(closeout).forEach((key) => {
      console.log('key ' + key, 'value = ', closeout[key])
    })
    //console.log(JSON.stringify(closeout));

    return closeout
  }

  return { buildPostechCloseout }
}

/**
 * helper function to build a paragraph for a single pile entry
 */
function buildPileParagraph_(pileObj) {
  console.log('..closeout builder for pileObj:')
  console.log(JSON.stringify(pileObj))
  let capacity
  if (pileObj.torqueMin.toString().toLowerCase() == 'bedrock') {
    capacity = 10000
  } else {
    capacity = Math.round(calcPileCapacity_(pileObj.od_in, pileObj.torqueMin, 2.5))
  }
  console.log('..capacity = ' + capacity)

  let maxCapacity
  if (pileObj.torqueMax != null && pileObj.torqueMax.toString().toLowerCase() == 'bedrock') {
    maxCapacity = 10000
  } else {
    maxCapacity = Math.round(calcPileCapacity_(pileObj.od_in, pileObj.torqueMax, 2.5))
  }
  //var maxCapacit
  let strPara

  if (pileObj.torqueMax == null || pileObj.torqueMax == 0 || pileObj.torqueMax == '') {
    //single torque value specified:
    strPara =
      'All the ' +
      pileObj.size +
      ' piles reached a minimum installation torque of ' +
      pileObj.torqueMin +
      ' ft-lbs, giving each ' +
      pileObj.size +
      ' pile a minimum allowable load carrying capacity of ' +
      capacity +
      ' lbs. '
  } else {
    //torque range is specified:
    strPara =
      'All the ' +
      pileObj.size +
      ' piles reached a minimum installation torque of between ' +
      pileObj.torqueMin +
      ' ft-lbs and ' +
      pileObj.torqueMax +
      ' ft-lbs, giving each ' +
      pileObj.size +
      ' pile a minimum allowable load carrying capacity of between ' +
      capacity +
      ' lbs and ' +
      maxCapacity +
      ' lbs. '
  }

  return strPara
}

/**
 * Calculate Pile capacity based on torque
 * @param {Number} dia The pile shaft diameter in decimal inches
 * @param {Number} torque The install torque in ft-lbs
 * @return {Number} The SLS pile capacity in lbs;
 */
function calcPileCapacity_(dia: number, torque: number, fos = 2.5) {
  const lam = 22
  const deff = Math.pow(dia, 0.92)
  const kt = lam / deff
  //const fos = 2.5;
  return Math.round((kt * torque) / fos / 100) * 100
}

/**
 * get CofA and Building Code from province
 */
export function getCofA(province: String) {
  let CofA
  let buildingCode

  switch (province) {
    case 'AB':
      CofA = 'APEGA P12834'
      buildingCode = 'National Building Code - 2023 Alberta Edition'
      break

    case 'ON':
      CofA = 'PEO CofA # 100523034'
      buildingCode = '2024 Ontario Building Code'
      break

    case 'BC':
      CofA = 'PTP 1000603'
      buildingCode = '2024 British Columbia Building Code'
      break

    case 'NS':
      CofA = '#51205'
      buildingCode = '2019 Nova Scotia Building Code'
      break

    case 'SK':
      CofA = 'CofA #51190'
      buildingCode = '2020 National Building Code of Canada'
      break

    case 'NB':
      CofA = 'CofA F2042'
      buildingCode = '2020 National Building Code of Canada'
      break

    case 'MB':
      CofA = 'CofA No. 6099'
      buildingCode = '2020 National Building Code of Canada'
      break

    default:
    //nothing
  }

  return { CofA: CofA, buildingCode: buildingCode }
}
